import { render, staticRenderFns } from "./login-footer.vue?vue&type=template&id=5dc5edb2&scoped=true&"
import script from "./login-footer.vue?vue&type=script&lang=js&"
export * from "./login-footer.vue?vue&type=script&lang=js&"
import style0 from "./login-footer.vue?vue&type=style&index=0&id=5dc5edb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc5edb2",
  null
  
)

export default component.exports